/***********************************************************/
/***********************************************************/
/* apiKeysModule Module */
/***********************************************************/
/***********************************************************/

var apiKeysModule = (function() {
  var url = '/account/api/';

  function init() {
    getItems();

    $('.api-keys-wrap .btn-generate').on('click', function() {
      var options = {
        title: 'Generate API Key',
        btnSubmitText: 'Submit',
        okCallback: function(accessLevel, ipAddresses, reason) {
          generate(accessLevel, ipAddresses, reason);
        }
      };
      var popupApiKeyForm = new PopupApiKeyForm(options);
      popupApiKeyForm.render();
    });

    $('.api-keys-wrap').on('click', '.btn-delete-item', function() {
      var id = $(this).closest('tr').data('id'),
        dateCreated = $(this).closest('tr').data('datecreated');

      var options = {
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete the API Key created on ' + dateCreated + '?',
        cancel: true,
        okCallback: function() {
          deleteItem(id);
        }
      };
      var popup = new Popup(options);
      popup.render();

      $('.popup .ok').text('Delete');
    });

    $('.api-keys-wrap').on('click', '.btn-edit-item', function() {
      var id = $(this).closest('tr').data('id'),
        accessLevel = $(this).closest('tr').data('accesslevel'),
        ipAddresses = $(this).closest('tr').data('ipaddresses').replaceAll(',', '\n');

      var options = {
        edit: true,
        title: 'Edit API Key Access',
        btnSubmitText: 'Update',
        accessLevel: accessLevel,
        ipAddresses: ipAddresses,
        okCallback: function(accessLevel, ipAddresses) {
          updateItem(id, accessLevel, ipAddresses);
        }
      };
      var popupApiKeyForm = new PopupApiKeyForm(options);
      popupApiKeyForm.render();
    });

    $('.api-keys-wrap').on('mouseover mouseleave', '.status-wrap', function(e) {
      if (e.type === 'mouseleave') {
        $('.status-tooltip').addClass('hide');
        return;
      }
      // if (!$(this).find('.status-tooltip').hasClass('hide')) {
      // 	$(this).find('.status-tooltip').addClass('hide');
      // 	return;
      // }

      $('.status-tooltip').addClass('hide');
      $(this).find('.status-tooltip').removeClass('hide');
    });
  }

  function getItems() {
    var req = new Request(servicesUrl + url + 'get', {});

    req.success(function(res) {
      if (res.success) {
        listItems(res.items);
      }
    });

    req.error(function(res) {
      return false;
    });

    req.call();
  }

  function deleteItem(itemId) {
    var req = new Request(servicesUrl + url + 'delete', {
      id: itemId
    });

    req.success(function(res) {
      if (res.success) {
        $('.api-keys-table ').find('tr[data-id="' + itemId + '"]').remove();

        if ($('.api-keys-table tbody tr').length === 0) {
          $('.api-keys-table tbody').html('<tr><td colspan="4" align="center">No API Keys found</td></tr>');
        }
      }
    });

    req.error(function(res) {
      return false;
    });

    req.call();
  }

  function updateItem(id, accessLevel, ipAddresses) {
    var req = new Request(servicesUrl + url + 'edit', {
      id: id,
      accessLevel: accessLevel,
      ipAddresses: ipAddresses
    });

    req.success(function(res) {
      if (res.success) {

        var options = {
          title: 'API Key Updated',
          message: 'The API Key access details has been updated',
          okCallback: function() {
            $('.backdrop1').remove(); // close the form popup
          }
        };

        var popup = new Popup(options);
        popup.render();

        res?.items && listItems(res.items);
      }
    });

    req.error(function(res) {
      if (res.error) {
        var options = {
          title: res.title,
          message: res.message,
        };

        var popup = new Popup(options);
        popup.render();
      }
    });

    req.call();
  }

  function listItems(items) {
    var accessLevels = ['Read', 'Write', 'Read/Write'];
    var requestStatus = ['pending', 'approved', 'rejected'];

    if (items.length) {
      $('.api-keys-table tbody').html('');
      $.each(items, function(i, item) {
        var dateCreated = moment(new Date(item.date)).format('DD MMM\'YY HH:mm');
        var statusIcon = cdnUrl + '/img/icon_' + requestStatus[item.status] + '.svg';

        var row = '<tr data-id="' + item.id + '" data-datecreated="' + dateCreated + '" data-ipaddresses="' + item.ipAddresses + '" data-accesslevel="' + item.accessLevel + '"><td><div class="status-wrap"><img class="icon-status" src="' + statusIcon + '" width="20" height="20"><span class="status-tooltip hide">' + requestStatus[item.status] + '</span></div></td><td>' + dateCreated + '</td><td>' + accessLevels[item.accessLevel - 1] + '</td><td>' + item.ipAddresses.replaceAll(',', ', ') + '</td><td class="actions"><button data-id="' + item.id + '" class="btn-edit-item"><img class="icon-edit" src="' + cdnUrl + '/img/icon_edit.svg"></button><button class="btn-delete-item"><img class="icon-delete" src="' + cdnUrl + '/img/icon_delete.svg"></button></td></tr>';
        $('.api-keys-table tbody').append(row);
      });
    } else {
      $('.api-keys-table tbody').html('<tr><td colspan="4" align="center">No API Keys found</td></tr>');
    }
  }

  function generate(accessLevel, ipAddresses, reason) {
    var req = new Request(servicesUrl + url + 'generate', {
      accessLevel: accessLevel,
      ipAddresses: ipAddresses,
      reason: reason
    });

    req.success(function(res) {
      if (res.success) {
        var options = {
          title: 'New API Key Generated',
          message: 'Please write down the API Key as it will only be shown now and cannot be retrieved later.',
          apiKey: res.apiKey,
          okCallback: function() {
            listItems(res.items);
          }
        };

        var popup = new PopupApiKeys(options);
        popup.render();
      }
    });

    req.error(function(res) {
      if (res.error) {
        var options = {
          title: res.title,
          message: res.message,
        };

        var popup = new Popup(options);
        popup.render();
      }
    });

    req.call();
  }


  return {
    init: init,
    generate: generate,
  }

}());